import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {TaskService} from '../../../../services/task.service';
import {DatePipe} from '@angular/common';
import {UtilsModule} from '../../../../utils/utils.module';

@Component({
  selector: 'app-work-relation',
  templateUrl: './work-relation.component.html',
  styleUrls: ['../parts.css']
})
export class WorkRelationComponent implements OnInit {
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  // 定时
  schedulerConditionDisplayText = '定时'; // 定时默认文字
  schedulerConditionData: any; // 存放定时数据
  schedulerConditionVisible: boolean; // 定时pop是否关闭
  // 分组
  groupConditionVisible: boolean; // 分组POP是否关闭
  departmentConditionVisible: boolean;
  workDefConditionVisible: boolean;
  groupConditionId = []; // 分组选中ID
  groupIdList = [];
  groupConditionDisplayText = '分组'; // 条件二默认文字
  departmentConditionId = null;
  departmentConditionDisplayText = '部门';
  departmentData: Array<any> = [];
  workDefConditionId = null;
  workDefConditionDisplayText = '班次';
  workDefData: Array<any> = [];
  // 其他
  isVisible = false; // 弹窗显示控制
  isConfirmLoading = false; // 确定按钮
  recipe;
  recipeId = null; // 自动化模板ID
  relationId;
  instanceData: any = {}; // 存放实例返填数据
  taskIntegrationData: any = {}; // 存放任务数据
  categorieId: string; // 存放当前目录ID
  backFillData: any;
  automation = {
    boardId: '',
    groupId: '',
    categoryId: '',
    relationId: '',
    // operationOrgCode: '',
    // workDefId: '',
    schedulerDescription: '',
    instanceDescription: '',
    schedulerConfig: {},
    taskMapping: {},
    pulseMapping: {},
    auditCenter: {}
  }; // 存放入参数据
  @ViewChild('pulseCard', { static: true }) pulseCard: any;
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private taskService: TaskService,
    private utilsModule: UtilsModule
  ) { }

  ngOnInit(): void {
    if (this.boardData && JSON.stringify(this.boardData) !== '{}') {
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
    }
    // 处理返填数据
    // 反填分组
    if (this.instanceData.config && this.instanceData.config.groupId) {
      this.groupIdList = this.instanceData.config.groupId.split(',');
    }
    if (this.groupIdList.length) {
      const _title = [];
      this.boardGroupData.forEach((item, index) => {
        this.groupIdList.forEach(_list => {
          if (item.id === _list) {
            _title.push(item.title);
          }
        });
      });
      this.groupConditionDisplayText = _title.join(',');
    }
    if (this.instanceData && this.instanceData.config) {
      // 触发发射事件
      this.automation = JSON.parse(JSON.stringify(this.instanceData.config));
      this.backFillData = this.automation.taskMapping;
      // 反填定时
      this.schedulerConditionData = this.utilsModule.formatDateByGeneral(new Date()) + ' ' + this.automation.schedulerConfig['time'];
      this.schedulerConditionDisplayText = this.automation.schedulerConfig['time'] ? this.automation.schedulerConfig['time'] : '定时';
    }
    // 带入菜单ID
    // this.departmentConditionId = this.automation.operationOrgCode;
    this.automation.categoryId = this.categorieId;
    this.automation.relationId = this.relationId;
    if (this.recipe && this.recipe.auditCenter) {
      this.automation.auditCenter = this.recipe.auditCenter;
    }
    // this.getDepartment();
    this.packageData();
  }

  // 获取定时数据
  // getSchedulerData(event) {
  //   this.schedulerConditionVisible = false;
  //   this.schedulerConditionDisplayText = event.text;
  //   this.schedulerConditionData = event.config;
  //   this.automation.schedulerDescription = this.schedulerConditionDisplayText;
  //   this.automation.schedulerConfig = this.schedulerConditionData;
  //   this.packageData();
  // }
  // 分组变更
  groupConditionChange(item) {
    if (item && item.length) {
      const _title = [];
      item.forEach(_list => {
        this.boardGroupData.forEach(_g => {
          if (_list === _g.id) {
            _title.push(_g.title);
          }
        });
      });
      this.groupConditionDisplayText = _title.join(',');
      // this.groupConditionId = item.id;
      this.automation.groupId = item.toString();
      // this.groupConditionVisible = false;
      this.packageData();
    } else {
      this.groupConditionDisplayText = '分组';
    }
  }
  // departmentConditionChange(item) {
  //   this.departmentConditionDisplayText = item.name;
  //   this.departmentConditionId = item.id;
  //   this.departmentConditionVisible = false;
  //   this.automation.operationOrgCode = this.departmentConditionId;
  //   const params = {operationOrgCode: item.code};
  //   this.getWorks(params);
  //   this.packageData();
  // }
  // workDefConditionChange(item) {
  //   this.workDefConditionId = item.id;
  //   this.workDefConditionDisplayText = item.name;
  //   this.workDefConditionVisible = false;
  //   this.automation.workDefId = this.workDefConditionId;
  //   this.packageData();
  // }
  // 弹窗创建任务
  openTaskDialog() {
    this.isVisible = true;
  }
  // 弹窗确定事件
  handleOk() {
    this.pulseCard.onSubmit();
    this.isVisible = false;
  }
  // 弹窗关闭事件
  handleCancel() {
    this.isVisible = false;
  }
  // 获取任务创建数据
  getTaskIntegrationData(event) {
    // this.backFillData = event;
    const obj: any = {};
    event.forEach((item, index) => {
      let mapObj: any;
      if (typeof item.mappingValue === 'string') {
        switch (item.type) {
          case 'dropdown':
            mapObj = {
              'fixedValue': {
                'ids': [item.mappingValue]
              }
            };
            break;
          case 'select':
            mapObj = {
              'fixedValue': {
                'option': item.mappingValue
              }
            };
            break;
          case 'button':
            mapObj = {
              'fixedValue': {
                'original': item.mappingValue
              }
            };
            break;
        }
      }
      if (item.type === 'dropdown' || item.type === 'select' || item.type === 'button') {
        obj[item.id] = mapObj;
      } else {
        const mpArr = [];
        item.mappingValue.forEach((m, i) => {
          mapObj = {
            'type': 'field',
            'sourceField': {
              'id': m.id,
              'type': m.type ? m.type : 'text',
              'title': m.title
            }
          };
          mpArr.push(mapObj);
        });
        mpArr.unshift({'type': 'text', 'text': item.mappingFirstValue});
        mpArr.push({'type': 'text', 'text': item.mappingEndValue});
        obj[item.id] = {
          'targetField': {
            'id': item.id,
            'title': item.title,
            'type': item.type,
          },
          'mappingParts': mpArr
        };
      }
      this.automation.taskMapping['mappingConfig'] = obj;
    });
    this.packageData();
  }
  // 组件提交数据
  packageData() {
    // this.automation.instanceDescription = this.schedulerConditionDisplayText + '，根据任务管理的' + this.departmentConditionDisplayText + '及' + this.workDefConditionDisplayText + '规则，在' + this.groupConditionDisplayText + '中，创建任务';
    this.automation.instanceDescription = '每天' + this.schedulerConditionDisplayText + '，根据任务规则，在' + this.groupConditionDisplayText + '中，创建任务';
    this.nfDataChange.emit(this.automation);
  }

  // 获取当前提交状态，当所有必填项都填写时返回true
  getSubmitStatus(): boolean {
    return JSON.stringify(this.automation.schedulerConfig) !== '{}' &&
      this.groupIdList && this.groupIdList.length &&
      JSON.stringify(this.automation.taskMapping) !== '{}';
  }
  // 获取部门列表
  // getDepartment() {
  //   this.taskService.getTaskDepartment().subscribe( res => {
  //     this.departmentData = res && res['_embedded'] && res['_embedded'].vos ? res['_embedded'].vos : [];
  //     this.departmentConditionId = JSON.stringify(this.instanceData) !== '{}' ? this.instanceData.config.operationOrgCode : '';
  //     this.departmentData.forEach(item => {
  //       if (item.id === this.departmentConditionId) {
  //         this.departmentConditionDisplayText = item.name;
  //         const params = {operationOrgCode: item.code};
  //         this.getWorks(params);
  //       }
  //     });
  //   });
  // }
  // 班次
  // getWorks(params) {
  //   this.taskService.getWorkDefs(params).subscribe( res => {
  //     this.workDefData = res && res['_embedded'] && res['_embedded'].vos ? res['_embedded'].vos : [];
  //     this.workDefConditionId = JSON.stringify(this.instanceData) !== '{}' ? this.instanceData.config.workDefId : '';
  //     this.workDefData.forEach(item => {
  //       if (item.id === this.workDefConditionId) {
  //         this.workDefConditionDisplayText = item.name;
  //       }
  //     });
  //   });
  // }
  schedulerTimeChange(event) {
    if (event) {
      this.schedulerConditionDisplayText = this.utilsModule.formatTimeByGeneral(event);
      this.automation.schedulerConfig = {
        time: this.utilsModule.formatTimeByGeneral(event),
        type: 'daily',
        occurrences: '1',
        dateType: 'days'
      };
      this.packageData();
    }
  }
}
